import x from '../../../../assets/images/twitter.svg'
import linkedin from '../../../../assets/images/linkedin.svg'
import facebook from '../../../../assets/images/facebook.svg'

export const menuItems = [
	{ label: 'Privacy policy', path: '/privacy-policy' },
	{ label: 'Copyright statement', path: '/copyright-statement' },
	{ label: 'Cookie policy', path: '/cookie-policy' },
	{ label: 'Accessibility statement', path: '/accessibility-statement' },
	{ label: 'Content disclaimer', path: '/content-disclaimer' }
]

export const socialMediaLinks = [
	{ alt: 'Twitter', src: x, path: 'https://x.com/collegeofpolice' },
	{
		alt: 'LinkedIn',
		src: linkedin,
		path: 'https://www.linkedin.com/company/college-of-policing'
	},
	{
		alt: 'Facebook',
		src: facebook,
		path: 'https://www.facebook.com/CollegeOfPolicing'
	}
]

export const copyRightFooterText = `© College of Policing Ltd. All content (excluding logos, videos,
photographs and where otherwise stated) is available for re-use under
the Non-Commercial College Licence. (${new Date().getFullYear()}).`
